<template>
  <CommonChip
    dark
    :color="status === 'In Escrow' ? '#9CA88F' : 'grey'"
  >
    {{ status === 'Pending' ? 'Listing Pending' : status }}
  </CommonChip>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import CommonChip from '@/bundles/Common/components/chips/CommonChip.vue';

export default defineComponent({
  name: 'AvailabilityTransactionStatusChip',

  components: { CommonChip },

  props: {
    status: {
      type: String,
      required: true
    },
  },
});
</script>
